import React from "react";
import { all, takeLatest } from "redux-saga/effects";

import {
    AD_SLOT_RENDER_ENDED,
    AD_SLOT_UNREGISTER,
    AdSlotRenderEndedAction,
    AdSlotUnregisterAction,
} from "@/mk2/containers/AdSlot/AdSlot.actions";
import { PREFIX_AD_SLOT_BRANDING } from "@/mk2/containers/AdSlotBranding/AdSlotBranding";

function* brandingRendered({ slotId, event }: AdSlotRenderEndedAction) {
    const slotWrapper = document.getElementById(slotId);
    const slot = slotWrapper?.parentElement?.parentElement;

    const body = document.body;

    if (!event.isEmpty && event.size && Array.isArray(event.size)) {
        // set page to layout according to the size of creative
        // size '1x1' is returned from prebid line item.

        const creativeWidth = event.size[0];
        const creativeHeight = event.size[1];

        let layout;
        if (creativeWidth === 2000) {
            layout = "branding";
        } else if (creativeHeight >= 450) {
            // sometimes we've got from adx an ad, smaller than a requested branding 2000x1400, but tall for a
            // billboard, for example 1200x1000. We will show it as a branding
            layout = "branding";
        } else if (creativeWidth === 970) {
            layout = "billboard";
        } else if (creativeWidth === 1) {
            // Prisla kreativa z Prebidu a nemame informaciu o jej skutocnej
            // velkosti.
            // CeMi: 29.1.2021 skusam heuristiku, co sa pozrieme na velkost
            // slotu. Sme v handleri eventu 'SlotRenderEndedEvent', tak by
            // slot uz mohol byt resiznuty na spravnu velkost.
            if (slot && slot.clientHeight === 250) {
                layout = "billboard";
            } else if (slot && slot.clientHeight === 1400) {
                layout = "branding";
            } else {
                // neznama vyska, tak pouzi ako default layout billboard
                // (viac sa ich predava, vacsia sanca ze sa trafime)
                layout = "billboard";
            }
        }

        // Cleanup layouts
        if (layout === "branding") {
            body.classList.add("body--branding");
            body.classList.remove("body--billboard");
        } else if (layout === "billboard") {
            body.classList.remove("body--branding");
            body.classList.add("body--billboard");
        }

        if (slot) {
            if (layout === "branding") {
                slot.classList.add("slot--branding");
            } else {
                slot.classList.remove("slot--branding");
            }
        }
    } else {
        if (slot && slot.clientHeight === 0) {
            // reset to normal page layout to normal, we do not have branding
            slot.classList.remove("slot--branding");
            body.classList.remove("body--branding");
            body.classList.remove("body--billboard");
        }
    }

    // dole uvedená časť kódu je pokus o nápravu situácie, keď sa
    // branding kreatíva načíta, size sa zistí ako 1x1, nastaví sa
    // layout pre billboard.
    // Tento kód čaká 100ms a potom ak je výška slotu väčšia ako
    // 400px, tak prepne layout na branding.
    // TODO: tento kód by bolo dobré časom odstrániť, je to len
    // núdzové riešenie problému, ktorý by sa mal vyriešiť inak.
    setTimeout(() => {
        if (slot && slot.clientHeight > 400 && body.classList.contains("body--billboard")) {
            slot.classList.add("slot--branding");
            slot.classList.remove("slot--billboard");
            body.classList.add("body--branding");
            body.classList.remove("body--billboard");
        }
    }, 100);
}

function* brandingUnregistered({ slotId }: AdSlotUnregisterAction) {
    const body = document.body;
    const slotWrapper = document.getElementById(slotId);
    const slot = slotWrapper?.parentElement?.parentElement;

    if (slot) {
        slot.classList.remove("slot--branding");
    }
    body.classList.remove("body--branding");
    body.classList.remove("body--billboard");
}

export default function* root() {
    yield all([
        takeLatest(
            (action) =>
                action.type === AD_SLOT_RENDER_ENDED &&
                action.slotId.startsWith(PREFIX_AD_SLOT_BRANDING),
            brandingRendered,
        ),
        takeLatest(
            (action) =>
                action.type === AD_SLOT_UNREGISTER &&
                action.slotId.startsWith(PREFIX_AD_SLOT_BRANDING),
            brandingUnregistered,
        ),
    ]);
}
